module.exports = __webpack_public_path__ + "img/1-7.f7839071.png";